import { _ as _baseIsNative } from "./auth-service-tools1295.js";
import { _ as _getValue } from "./auth-service-tools1296.js";
var baseIsNative = _baseIsNative,
    getValue = _getValue;

function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}

var _getNative = getNative;
export { _getNative as _ };